"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyInputResolver = exports.getPropertyInputResolverType = exports.mapDefaultResolverToPropertyInput = exports.getPropertyInputResolverCreators = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _curry = _interopRequireDefault(require("transmute/curry"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _PropertyIdentifier = require("customer-data-objects/property/PropertyIdentifier");

var _ReferenceObjectTypes = _interopRequireDefault(require("reference-resolvers/constants/ReferenceObjectTypes"));

var _CampaignReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/CampaignReferenceResolver"));

var _CompanyReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/CompanyReferenceResolver"));

var _ContactReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/ContactReferenceResolver"));

var _ContactByEmailReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/ContactByEmailReferenceResolver"));

var _ImportNameReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/ImportNameReferenceResolver"));

var _IntegrationNameReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/IntegrationNameReferenceResolver"));

var _MultiCurrencyCurrencyCodeResolver = _interopRequireDefault(require("reference-resolvers/resolvers/MultiCurrencyCurrencyCodeResolver"));

var _OwnerPagedReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/OwnerPagedReferenceResolver"));

var _PersonaReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/PersonaReferenceResolver"));

var _PipelineReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/PipelineReferenceResolver"));

var _PipelineStageReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/PipelineStageReferenceResolver"));

var _SalesforceCampaignListReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/SalesforceCampaignListReferenceResolver"));

var _TeamReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/TeamReferenceResolver"));

var _TicketPipelinesReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/TicketPipelinesReferenceResolver"));

var _TicketStagesReferenceResolver = _interopRequireDefault(require("reference-resolvers/resolvers/TicketStagesReferenceResolver"));

var _PropertyNameToReferenceType = _interopRequireDefault(require("customer-data-objects/property/PropertyNameToReferenceType"));

var _RESOLVERS;

var RESOLVERS = (_RESOLVERS = {}, (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.CAMPAIGN, _CampaignReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.COMPANY, _CompanyReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.CONTACT, _ContactReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.CONTACT_BY_EMAIL, _ContactByEmailReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.DEAL_PIPELINE_STAGE, _PipelineStageReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.DEAL_PIPELINE, _PipelineReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.IMPORT_NAME, _ImportNameReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.INTEGRATION_NAME, _IntegrationNameReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.MULTI_CURRENCY_CURRENCY_CODE, _MultiCurrencyCurrencyCodeResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.OWNER, _OwnerPagedReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.PERSONA, _PersonaReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.SALESFORCE_CAMPAIGN_LIST, _SalesforceCampaignListReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.TEAM, _TeamReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.TICKET_PIPELINE, _TicketPipelinesReferenceResolver.default), (0, _defineProperty2.default)(_RESOLVERS, _ReferenceObjectTypes.default.TICKET_STAGE, _TicketStagesReferenceResolver.default), _RESOLVERS);

var getReferenceObjectType = function getReferenceObjectType(property, objectType) {
  return property.referencedObjectType || _PropertyNameToReferenceType.default[objectType] && _PropertyNameToReferenceType.default[objectType][property.name] || null;
};

var isAssociatedCompany = function isAssociatedCompany(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && property.name === 'associatedcompanyid';
};

var isContactEmail = function isContactEmail(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && property.name === 'email';
};

var isDomain = function isDomain(property, objectType) {
  return objectType === _ObjectTypes.COMPANY && property.name === 'domain';
};

var isHubSpotCampaign = function isHubSpotCampaign(property) {
  return property.name === 'hs_analytics_first_touch_converting_campaign' || property.name === 'hs_analytics_last_touch_converting_campaign';
};

var isParentCompany = function isParentCompany(property) {
  return property.name === 'hs_parent_company_id';
};

var isDealPipeline = function isDealPipeline(property, objectType) {
  return objectType === _ObjectTypes.DEAL && property.name === 'pipeline';
};

var isDealStage = function isDealStage(property, objectType) {
  return objectType === _ObjectTypes.DEAL && property.name === 'dealstage';
};

var isImportId = function isImportId(property, isImport) {
  return isImport && property.name === 'hs_analytics_source_data_2';
};

var isIntegrationAppId = function isIntegrationAppId(property, isIntegration) {
  return isIntegration && property.name === 'hs_analytics_source_data_2';
};

var isOwner = function isOwner(property, objectType) {
  return getReferenceObjectType(property, objectType) === _ReferenceObjectTypes.default.OWNER;
};

var isPersona = function isPersona(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && property.name === 'hs_persona';
};

var isSalesForceCampaign = function isSalesForceCampaign(property, objectType) {
  return objectType === _ObjectTypes.CONTACT && property.name === 'salesforcecampaignids';
};

var isTeam = function isTeam(property) {
  return property.name === 'hubspot_team_id';
};

var isTicketPipeline = function isTicketPipeline(property, objectType) {
  return objectType === _ObjectTypes.TICKET && property.name === 'hs_pipeline';
};

var isTicketStage = function isTicketStage(property, objectType) {
  return objectType === _ObjectTypes.TICKET && property.name === 'hs_pipeline_stage';
};

var getPropertyInputResolverCreators = function getPropertyInputResolverCreators() {
  return RESOLVERS;
};

exports.getPropertyInputResolverCreators = getPropertyInputResolverCreators;
var mapDefaultResolverToPropertyInput = (0, _curry.default)(function (resolverType, resolvers, props) {
  return props.resolver ? {
    resolver: props.resolver
  } : resolvers ? {
    resolver: resolvers[resolverType]
  } : {};
});
exports.mapDefaultResolverToPropertyInput = mapDefaultResolverToPropertyInput;

var getPropertyInputResolverType = function getPropertyInputResolverType(property, objectType) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      isImport = _ref.isImport,
      isIntegration = _ref.isIntegration;

  if (isContactEmail(property, objectType)) {
    return _ReferenceObjectTypes.default.CONTACT_BY_EMAIL;
  } else if ((0, _PropertyIdentifier.isCurrency)(property)) {
    return _ReferenceObjectTypes.default.MULTI_CURRENCY_INFORMATION;
  } else if (isDealPipeline(property, objectType) || isDealStage(property, objectType)) {
    return _ReferenceObjectTypes.default.DEAL_PIPELINE;
  } else if (isAssociatedCompany(property, objectType) || isDomain(property, objectType) || isParentCompany(property)) {
    return _ReferenceObjectTypes.default.COMPANY;
  } else if (isHubSpotCampaign(property)) {
    return _ReferenceObjectTypes.default.CAMPAIGN;
  } else if (isImportId(property, isImport)) {
    return _ReferenceObjectTypes.default.IMPORT_NAME;
  } else if (isIntegrationAppId(property, isIntegration)) {
    return _ReferenceObjectTypes.default.INTEGRATION_NAME;
  } else if (isOwner(property, objectType)) {
    return _ReferenceObjectTypes.default.OWNER;
  } else if (isPersona(property, objectType)) {
    return _ReferenceObjectTypes.default.PERSONA;
  } else if (isSalesForceCampaign(property, objectType)) {
    return _ReferenceObjectTypes.default.SALESFORCE_CAMPAIGN_LIST;
  } else if (isTeam(property)) {
    return _ReferenceObjectTypes.default.TEAM;
  } else if (isTicketPipeline(property, objectType) || isTicketStage(property, objectType)) {
    return _ReferenceObjectTypes.default.TICKET_PIPELINE;
  }

  return null;
};

exports.getPropertyInputResolverType = getPropertyInputResolverType;

var getPropertyInputResolver = function getPropertyInputResolver(referenceResolvers, property, objectType, options) {
  var type = getPropertyInputResolverType(property, objectType, options);
  return referenceResolvers[type] || null;
};

exports.getPropertyInputResolver = getPropertyInputResolver;